import clsx from "clsx";

interface FormLabelProps {
  label?: string;
  inputId?: string;
  className?: string;
  isOptional?: boolean;
  isRequired?: boolean;
}

const FormLabel: React.FC<FormLabelProps> = ({
  label = "",
  inputId = "",
  className = "",
  isOptional = false,
  isRequired = false,
}) => {
  if (!label) {
    return null;
  }

  return (
    <label
      htmlFor={inputId}
      className={clsx(
        "absolute left-3 top-1/2 -translate-y-1/2 px-1",
        "bg-transparent",
        "text-sm text-gray-500 dark:text-gray-400",
        "pointer-events-none origin-left",
        "transition-all duration-200 ease-out",

        // FLOAT ON FOCUS
        "group-focus-within:top-0",
        "group-focus-within:text-xs",
        "group-focus-within:font-medium",
        "group-focus-within:text-primary-600",
        "group-focus-within:bg-white",
        "group-focus-within:dark:bg-gray-900",

        // FLOAT WHEN VALUE EXISTS
        "group-data-[empty=false]:top-0",
        "group-data-[empty=false]:text-xs",
        "group-data-[empty=false]:bg-white",
        "group-data-[has-icon=true]:left-10",
        "group-data-[has-icon=true]:group-data-[empty=false]:left-3",
        "group-data-[has-icon=true]:group-focus-within:left-3",
        className,
      )}
    >
      <span className="flex items-center gap-1">
        {label}
        {isRequired && <span className="text-red-500 text-xs">*</span>}
        {isOptional && (
          <span className="text-gray-400 text-xs">(Optional)</span>
        )}
      </span>
    </label>
  );
};

export default FormLabel;
